export default __webpack_public_path__ + "static/media/kitchen4-afterF-1024w.5a22dc71.avif";